export type NoteSectionCacheDraft = {
  content?: {
    sections?: Array<{
      edited_text?: string | null;
    }>;
  };
};

export type SectionCacheReconcileRequest = {
  noteId: string;
  sectionIndex: number;
  requestId: string;
};

type NoteAiEditDirtyState = {
  'noteAiEdit/ui'?: {
    dirtySections?: Record<string, string>;
  };
};

export const updateNoteSectionEditedText = (
  draft: NoteSectionCacheDraft,
  sectionIndex: number,
  editedText: string,
) => {
  if (draft.content?.sections?.[sectionIndex]) {
    draft.content.sections[sectionIndex].edited_text = editedText;
  }
};

export const canReconcileSavedSectionContent = (
  state: unknown,
  sectionId: string | undefined,
  savedText: string,
) => {
  if (!sectionId) {
    return true;
  }

  const dirtySections = (state as NoteAiEditDirtyState)['noteAiEdit/ui']?.dirtySections;
  const currentDirtyText = dirtySections?.[sectionId];

  return currentDirtyText === undefined || currentDirtyText === savedText;
};

const getSectionCacheReconcileKey = ({ noteId, sectionIndex }: SectionCacheReconcileRequest) =>
  `${noteId}:${sectionIndex}`;

export const createSectionCacheReconcileTracker = () => {
  const latestRequests = new Map<string, string>();

  return {
    track(request: SectionCacheReconcileRequest) {
      latestRequests.set(getSectionCacheReconcileKey(request), request.requestId);
    },

    isLatest(request: SectionCacheReconcileRequest) {
      return latestRequests.get(getSectionCacheReconcileKey(request)) === request.requestId;
    },

    clearIfLatest(request: SectionCacheReconcileRequest) {
      if (this.isLatest(request)) {
        latestRequests.delete(getSectionCacheReconcileKey(request));
      }
    },
  };
};
